"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs — v1
 * API v1 documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfUpsertListingUrlDto = instanceOfUpsertListingUrlDto;
exports.UpsertListingUrlDtoFromJSON = UpsertListingUrlDtoFromJSON;
exports.UpsertListingUrlDtoFromJSONTyped = UpsertListingUrlDtoFromJSONTyped;
exports.UpsertListingUrlDtoToJSON = UpsertListingUrlDtoToJSON;
exports.UpsertListingUrlDtoToJSONTyped = UpsertListingUrlDtoToJSONTyped;
/**
 * Check if a given object implements the UpsertListingUrlDto interface.
 */
function instanceOfUpsertListingUrlDto(value) {
    if (!('listing_url' in value) || value['listing_url'] === undefined)
        return false;
    return true;
}
function UpsertListingUrlDtoFromJSON(json) {
    return UpsertListingUrlDtoFromJSONTyped(json, false);
}
function UpsertListingUrlDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'listing_url': json['listing_url'],
    };
}
function UpsertListingUrlDtoToJSON(json) {
    return UpsertListingUrlDtoToJSONTyped(json, false);
}
function UpsertListingUrlDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'listing_url': value['listing_url'],
    };
}
